import { i18n } from '@services/i18n';
import { I18nextProvider } from 'react-i18next';

export const I18nProvider = ({ children }: { children: React.ReactNode }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);
